import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

const cartAtom = atomWithStorage("cart", {
  cartItemCount: 0,
});

const useCartStore = () => {
  const [cart, setCart] = useAtom(cartAtom);

  const setCartItemCount = (count) => {
    setCart({
      ...cart,
      cartItemCount: Number(count) || 0,
    });
  };
  return {
    cartItemCount: cart.cartItemCount,
    setCartItemCount,
  };
};

export default useCartStore;
